import { render, staticRenderFns } from "./AddComponent.vue?vue&type=template&id=d0bc8088&scoped=true&"
import script from "./AddComponent.vue?vue&type=script&lang=ts&"
export * from "./AddComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AddComponent.vue?vue&type=style&index=0&id=d0bc8088&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0bc8088",
  null
  
)

export default component.exports